import { useState } from "react";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { offsetDateByMinutes } from "utils";
import useUniversalStore from "store/universalStore";
import { reminderAPI } from "services";
import { toast } from "sonner";

const AddReminder = () => {
    const { accountId } = useUniversalStore((state) => state);
    const [reminder, setReminder] = useState(null);
    const [scheduleReminder, setScheduleReminder] = useState(offsetDateByMinutes(5));
    const [edit, setEdit] = useState(false);

    const currentDateTime = dayjs(scheduleReminder);
    const today = dayjs(); // Get the current date and time

    const handleClose = () => setReminder(null);

    const handleChangeDate = (e) => {
        const newDate = new Date(e);
        const currentDate = new Date();
        if (newDate < currentDate) return;
        setSheduleReminder(newDate); // only return future dates
    };

    //method to shedule reminder
    const handleSchedule = async (e) => {
        e.preventDefault();
        try {
            const reminder = await reminderAPI.addReminder(accountId, scheduleReminder, true);
            if (reminder) {
                setReminder(reminder);
                toast.success("Reminder scheduled successfully!");
            }
        } catch (error) {
            console.log("error", error);
            toast.error("Failed to schedule Reminder!");
        }
    };

    // Handle time change
    const handleTimeChange = (e) => setScheduleReminder(new Date(e));

    // Add this function to check if selected time is valid
    const isTimeValid = () => {
        const selectedTime = dayjs(scheduleReminder);
        return selectedTime.isAfter(dayjs());
    };

    return (
        <div className="animate__animated animate__fadeIn">
            <div className="mb-1">
                <label className="display-6 py-2 text-black">
                    When do you want to be Reminded?
                </label>
                <div className="d-flex py-3 w-100 justify-content-end">
                    <DatePicker
                        selected={scheduleReminder}
                        onChange={handleChangeDate}
                        dateFormat="dd-MM-yyyy"
                        minDate={offsetDateByMinutes(5)}
                        className="form-control"
                        placeholderText="Select Date"
                    />
                    <DatePicker
                        selected={scheduleReminder}
                        onChange={handleTimeChange}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="hh:mm aa"
                        className="form-control"
                        placeholderText="Select Time"
                        filterTime={(time) => {
                            const selectedDate = dayjs(scheduleReminder);
                            const isToday = selectedDate.isSame(today, 'day');
                            if (!isToday) return true;
                            return dayjs(time).isAfter(dayjs());
                        }}
                    />
                </div>
            </div>
            <div className="row my-3">
                <div className="col-md-6 mb-2">
                    <button
                        type="cancel"
                        className="w-100 btn btn-outline-app"
                        data-bs-dismiss="offcanvas"
                        onClick={() => (edit ? setEdit(false) : handleClose())}
                    >
                        <b className="fs-5">Cancel</b>
                    </button>
                </div>
                <div className="col-md-6">
                    <button
                        type="submit"
                        className="btn btn-app block py-2 w-100"
                        data-bs-dismiss="offcanvas"
                        disabled={!isTimeValid()}
                        onClick={handleSchedule}>
                        <b className="fs-5">Schedule</b>
                    </button>
                </div>
            </div>
            <br />
        </div>
    )
}

export default AddReminder;